import { WithClassName } from '@/types/component';
import { cn } from '@/utils/shad';
import { PropsWithChildren } from 'react';

/** Fixed 48px row matching the report toolbar (h-8 controls centered in h-12). */
export const APP_SHELL_TOOLBAR_ROW_CLASS = 'flex h-12 shrink-0 items-center';

export const APP_SHELL_TOOLBAR_SEPARATOR_CLASS = 'h-px shrink-0 bg-border/60';

export function AppShellToolbarSeparator() {
  return <div aria-hidden className={APP_SHELL_TOOLBAR_SEPARATOR_CLASS} />;
}

type Props = PropsWithChildren & WithClassName;

export function TableHeaderToolsContainer({ className, children }: Props) {
  return (
    <div className="sticky top-0 z-50 shrink-0 bg-background">
      <header className={cn(APP_SHELL_TOOLBAR_ROW_CLASS, 'justify-between gap-2 px-8', className)}>{children}</header>
      <AppShellToolbarSeparator />
    </div>
  );
}
